import request from 'crm/utils/request'
import api from 'crm/common/api/group-grouping'
import {format} from 'utils'
import qs from 'qs'

export async function getGroupList(params) {
    return request(`${api.getGroupList.url}?${qs.stringify(params)}`)
}

export async function getGroupGrouping() {
    return request(api.getGroupGrouping.url)
}

export async function deleteGrouping(payload) {
    return request(`${format(api.deleteGrouping.url, {id: payload.id})}`, {
        method: api.deleteGrouping.type,
    })
}

export async function addGrouping(payload) {
    return request(api.addGrouping.url, {
        method: api.addGrouping.type,
        body: payload.body,
    })
}

export async function editGrouping(payload) {
    return request(`${format(api.editGrouping.url, {id: payload.id})}`, {
        method: api.editGrouping.type,
        body: payload.body,
    })
}

export async function moveGrouping(payload) {
    return request(api.moveGrouping.url, {
        method: api.moveGrouping.type,
        body: payload.body,
    })
}

export async function getMoveCount(payload) {
    return request(api.getMoveCount.url, {
        method: api.getMoveCount.type,
        body: payload.body,
    })
}
